module.exports = __webpack_public_path__ + "static/media/inv_large.b45ff05c.jpeg";